// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2nBcF","title":"styles_title__1MQNt"};